import { TypographyColor } from 'melp-design/components';
import { TaxExemptionStatus } from './shop.types';

export const SUPPORTED_TAX_EXEMPTION_COUNTRIES = ['EST'] as const;
export type SupportedTaxExemptionCountry =
  (typeof SUPPORTED_TAX_EXEMPTION_COUNTRIES)[number];

export const COLOR_BY_TAX_EXEMPTION_STATUS: Record<
  TaxExemptionStatus,
  TypographyColor
> = {
  exempt: 'success',
  'non-exempt': 'error',
  undefined: 'textPrimary',
};
